<div class="sdp-gateway-pending-state">
	<div *ngIf="!isGatewayDead; else stateError">
		<div *ngIf="!isProvisioning; else provisioning">
			<button
				mat-raised-button
				(click)="accept()"
				color="accent"
				matTooltip="{{ 'gateway.accept.icon.tooltip' | translate }}"
			>
				{{ "sdp.label.accept" | translate }}
			</button>
		</div>
		<ng-template #provisioning>
			<mat-spinner diameter="25"></mat-spinner>
		</ng-template>
	</div>
	<ng-template #stateError>
		<div class="sdp-gateway-state-error-message">
			<sdp-icon
				[icon]="warningIcon"
				matTooltip="{{'gateway.state.error.message' | translate}}"
			></sdp-icon>
		</div>
	</ng-template>
</div>